"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Icon_1 = __importDefault(require("./styledComponents/Icon"));

var ValueUp_1 = __importDefault(require("./styledComponents/ValueUp"));

var ValueDown_1 = __importDefault(require("./styledComponents/ValueDown"));

var Placeholder_1 = __importDefault(require("./styledComponents/Placeholder"));

var mobx_1 = require("mobx");

var ChangeIndicator_meta_1 = require("./ChangeIndicator.meta");

var ChangeIndicator =
/** @class */
function (_super) {
  __extends(ChangeIndicator, _super);

  function ChangeIndicator(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ChangeIndicator_meta_1.CHANGE_INDICATOR_CATEGORY_KEY;
    _this.componentKey = ChangeIndicator_meta_1.CHANGE_INDICATOR_COMPONENT_KEY;

    _this.getFormattedValue = function (value, isPlaceholder) {
      var _a = _this.props,
          format = _a.format,
          formatPlaceholder = _a.formatPlaceholder;
      return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(format) && (!isPlaceholder || formatPlaceholder) ? ksys_app_template_1.utils.replacePlaceholders({
        value: value
      }, format) : value;
    };

    return _this;
  }

  Object.defineProperty(ChangeIndicator.prototype, "iconPosition", {
    get: function get() {
      var icon = this.props.icon;

      if (this.direction === 'zero') {
        return 'none';
      }

      var defaultIcon = {
        show: true,
        position: 'right'
      };
      var iconProps = Object.assign(defaultIcon, icon);
      return iconProps.show && iconProps.position;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChangeIndicator.prototype, "direction", {
    get: function get() {
      var _a = this.props,
          directionValue = _a.directionValue,
          _b = _a.value,
          value = _b === void 0 ? 0 : _b;
      var usedValue = directionValue || value;

      if (typeof usedValue === 'string') {
        usedValue = usedValue.replace(',', '').replace(' ', '').replace(String.fromCharCode(160), '').replace(String.fromCharCode(8722), '-');
        usedValue = parseFloat(usedValue);
      }

      return usedValue > 0 ? 'up' : usedValue < 0 ? 'down' : 'zero';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChangeIndicator.prototype, "icon", {
    get: function get() {
      var asset = this.direction === 'down' ? 'overview.changeIndicator.changeDownIcon' : 'overview.changeIndicator.changeUpIcon';
      return react_1.default.createElement(Icon_1.default, {
        asset: asset
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChangeIndicator.prototype, "value", {
    get: function get() {
      var _a = this.props,
          _b = _a.value,
          value = _b === void 0 ? 0 : _b,
          _c = _a.placeholder,
          placeholder = _c === void 0 ? 0 : _c;
      var direction = this.direction;

      if (direction !== 'zero') {
        var ValueComponent = direction === 'up' ? ValueUp_1.default : ValueDown_1.default;
        var valueContent = this.getFormattedValue(value);
        return react_1.default.createElement(ValueComponent, null, valueContent);
      }

      var placeholderContent = this.getFormattedValue(placeholder, true);
      return react_1.default.createElement(Placeholder_1.default, null, placeholderContent);
    },
    enumerable: true,
    configurable: true
  });

  ChangeIndicator.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.iconPosition === 'left' && this.icon, this.value, this.iconPosition === 'right' && this.icon);
  };

  __decorate([mobx_1.computed], ChangeIndicator.prototype, "iconPosition", null);

  __decorate([mobx_1.computed], ChangeIndicator.prototype, "direction", null);

  __decorate([mobx_1.computed], ChangeIndicator.prototype, "icon", null);

  __decorate([mobx_1.computed], ChangeIndicator.prototype, "value", null);

  ChangeIndicator = __decorate([mobx_react_1.observer], ChangeIndicator);
  return ChangeIndicator;
}(shared_1.ComponentBase);

exports.ChangeIndicator = ChangeIndicator;
exports.default = shared_1.InjectedStyledComponent(ChangeIndicator, ChangeIndicator_meta_1.CHANGE_INDICATOR_CATEGORY_KEY, ChangeIndicator_meta_1.CHANGE_INDICATOR_COMPONENT_KEY);